import NotificationCard from "./NotificationCard";

export default function VideoNotificationCard(props) {
    return (
        <NotificationCard
            {...props}
            type="video"
            destination={"/video/" + props.notification.file}
            mediaUrl={
                "https://vz-db0e7359-d70.b-cdn.net/" +
                props.notification.file +
                "/thumbnail.jpg"
            }
            mediaAlt="Video thumbnail"
            showComments
        />
    );
}
